import {
  FormPageLayout,
  FormInput,
  FormGetter,
  DataTableExRef,
  FormTabs,
  FormTab,
  SelectInput,
  Grid,
} from '@kirz/mui-admin';
import { Box, Button } from '@mui/material';
import { ShapeOutline, Plus, FormatListBulleted } from 'mdi-material-ui';
import React, { useRef } from 'react';

import { CATEGORY_TYPE_ITEMS } from 'constants/other';

import { CategoryTemplatesTable } from '../components/CategoryTemplatesTable';

export function Category() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <FormPageLayout
      source="category"
      breadcrumbs={[
        {
          text: 'Категории',
          icon: ShapeOutline,
          href: '/categories',
        },
        (item) => ({
          text: item.name || 'Новая категория',
          copyOnClick: true,
        }),
      ]}
      breadcrumbsDeps={['name']}
      defaultRoute="/categories"
    >
      <Grid container spacing={2}>
        <FormInput name="name" label="Название" required md={6} />
        <SelectInput
          name="type"
          label="Тип"
          required
          items={CATEGORY_TYPE_ITEMS}
          md={3}
          disabled
        />
        <Grid xs={12}>
          <FormGetter
            names={['id', 'type']}
            render={(x) => (
              <Box
                sx={{
                  overflow: 'hidden',
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <CategoryTemplatesTable
                  id="category-templates-table"
                  ref={tableRef}
                  disableInitialization={!x.id}
                  categoryId={x.id}
                  categoryType={x.type}
                  searchFilter={{
                    slots: {
                      beforeSearch: (
                        <Button
                          startIcon={<Plus />}
                          variant="outlined"
                          size="small"
                          sx={{ px: 4, mr: 3, whiteSpace: 'pre' }}
                          onClick={() => {
                            tableRef.current?.openFormDialog();
                          }}
                        >
                          Добавить шаблон
                        </Button>
                      ),
                    },
                    filter(search) {
                      return {
                        _and: [
                          {
                            template: { name: { _ilike: `%${search}%` } },
                          },
                        ],
                      };
                    },
                  }}
                  sx={{
                    mt: 1,
                    minHeight: 400,

                    borderColor: 'transparent',
                  }}
                />
              </Box>
            )}
          />
        </Grid>
      </Grid>
    </FormPageLayout>
  );
}
